import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { useMapContext } from 'widgets/choroplethMap/contexts/mapContext';
import { Colors } from '@blueprintjs/core';
import { SELECTED_FEATURE_PROPERTY } from 'widgets/choroplethMap/constants/mapConstants';
import Space from '../../Space';
import Line from '../../Line';
import * as turf from '@turf/turf';
import commaSeparate from 'widgets/choroplethMap/helpers/numberFormatters/commaSeperate';
import { useChoroplethContext } from 'widgets/choroplethMap/contexts/choroplethContext';

export default function Modal() {
	const [{ selectedFeatureProperty }] = useMapContext();
	const [{ hoveredPolygon, choroplethData }] = useChoroplethContext();
	const [pointCount, setPointCount] = useState<number>(0);
	const [value, setValue] = useState<number>(0);
	const [latitude, setLatitude] = useState<number>();
	const [longitude, setLongitude] = useState<number>();

	useEffect(() => {
		if (!hoveredPolygon) return;
		const center = turf.center(hoveredPolygon);
		const latitude = center?.geometry?.coordinates?.[1];
		const longitude = center?.geometry?.coordinates?.[0];
		setLongitude(longitude);
		setLatitude(latitude);
	}, [hoveredPolygon]);

	useEffect(() => {
		const tagId = hoveredPolygon?.properties?.['TagId'];
		setPointCount(Number(choroplethData?.[tagId] ?? 0));
	}, [hoveredPolygon, choroplethData]);

	useEffect(() => {
		const value = hoveredPolygon?.properties?.[SELECTED_FEATURE_PROPERTY];
		setValue(value);
	}, [hoveredPolygon]);

	if (!hoveredPolygon) return null;
	return (
		<Wrapper>
			<Title>Choropleth</Title>
			<Space space={'6px'} isVertical={true} />
			<Line isVertical={false} />
			<Space space={'6px'} isVertical={true} />
			<Row>
				<SubTitle>{selectedFeatureProperty ? selectedFeatureProperty + ':' : 'Point Count:'}</SubTitle>
				<Value>{commaSeparate(pointCount)}</Value>
			</Row>
			<Row>
				<SubTitle>Latitude:</SubTitle>
				<Value>{latitude}</Value>
			</Row>
			<Row>
				<SubTitle>Longitude:</SubTitle>
				<Value>{longitude}</Value>
			</Row>
		</Wrapper>
	);
}

const Wrapper = styled.div`
	position: absolute;
	right: 12px;
	top: 12px;
	padding: 12px;
	width: 300px;
	background: ${Colors.WHITE};
`;
const Row = styled.div`
	display: flex;
`;
const Title = styled.div`
	font-weight: bold;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
	font-size: 14px;
`;
const SubTitle = styled.div`
	font-weight: bold;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex: 1;
	font-size: 12px;
`;

const Value = styled.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex: 1;
	font-size: 12px;
`;
